import { OnInit, Component } from '@angular/core';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UtilService } from 'src/app/shared/services/util.service';
import * as moment from 'moment';

@Component({
    selector: 'app-reporte-detalle-abandonados',
    templateUrl: './reporte-detalle-abandonados.component.html',
    styleUrls: ['./../reporte-UAC.component.scss']
})

export class ReporteDetalleAbandonadosComponent implements OnInit {
    public filtroTramite: string;
    public filtroFechaInicio: Date;
    public filtroFechaFin: Date;
    public filtroTramiteExcel: string;
    public filtroFechaInicioExcel: Date;
    public filtroFechaFinExcel: Date;
    public tramites: string[];
    public validar = true;
    public validarExportar = true;
    public datosArchivo: any;
    public abandonados: string[];
    public placeholderDate: string;

    public paginas: number[];
    public inicio: number;
    public fin: number;

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService
    ) {
    }

    ngOnInit() {
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.obtenerTramite();
    }

    /*
    * Consulta los Trámites Existente
    */
    public obtenerTramite() {
        this.spinner.show();
        const serviceProvider = 'tramiteUAC';
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=estado', ConstantesService.ESTADO_TRAMITE_ACTIVO]);
        let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
        url = url + '&orderBy=nombre$ASC';
        this.global.getGenerico(url).subscribe(
            data => {
                this.tramites = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Cargar los Trámites');
            }
        );
    }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    public GenerarReporteDetalleAbandonados() {
        if (this.filtroFechaInicio < this.filtroFechaFin || this.filtroFechaInicio.getTime() === this.filtroFechaFin.getTime()) {
            if (this.filtroFechaFin < new Date()) {
                this.GenerandoReporte();
            } else {
                this.alertService.generateAlertError('La fecha fin no puede ser superior a la fecha de sistema', '');
            }
        } else {
            this.alertService.generateAlertError('La fecha fin no puede ser inferior a la fecha inicio', '');
        }
    }

    /*
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    public GenerandoReporte() {
        this.spinner.show();
        this.filtroFechaInicioExcel = this.filtroFechaInicio;
        this.filtroFechaFinExcel = this.filtroFechaFin;
        this.filtroTramiteExcel = this.filtroTramite;
        this.validacion();
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['fechaInicio', this.filtroFechaInicio.getTime().toString()]);
        queryParams.push(['fechaFin', this.filtroFechaFin.getTime().toString()]);
        if (this.utilService.validarCamposObligatorios(this.filtroTramite)) {
            queryParams.push(['tramite', this.filtroTramite]);
        }
        queryParams.push(['nombreEvento', 'ABANDONADO']);
        const serviceProvider = 'reportePorNombreEventoTabla';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.postGenerico(url).subscribe(
            data => {
                if (data.length) {
                    this.abandonados = data;
                    this.validarExportar = false;
                    this.paginador();
                } else {
                    this.cathException('Consulta sin datos');
                    this.abandonados = undefined;
                }
            }, err => {
                this.cathException('El reporte no se ha podido generar');
            }
        );
    }

    /*
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    public GenerarReporteExportar() {
        this.spinner.show();
        this.validacion();
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['fechaInicio', this.filtroFechaInicio.getTime().toString()]);
        queryParams.push(['fechaFin', this.filtroFechaFin.getTime().toString()]);
        if (this.utilService.validarCamposObligatorios(this.filtroTramite)) {
            queryParams.push(['tramite', this.filtroTramite]);
        }
        queryParams.push(['nombreEvento', 'ABANDONADO']);
        const serviceProvider = 'reportePorNombreEvento';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.postGenerico(url).subscribe(
            data => {
                this.datosArchivo = data;
                this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                this.descargarArchivo();
            }, err => {
                this.cathException('El reporte no se ha podido exportar');

            }
        );
    }

    /*
     * Metodo que valida los campos obligatorios para porder habilitar el boton Generar Reporte
     */
    public validacion() {
        if ((this.filtroFechaInicio !== undefined && this.filtroFechaFin !== undefined)) {
            this.validar = false;
        } else {
            this.validar = true;
        }
        if (this.filtroTramiteExcel !== this.filtroTramite ||
            this.filtroFechaInicioExcel !== this.filtroFechaInicio ||
            this.filtroFechaFinExcel !== this.filtroFechaFin) {
            this.validarExportar = true;
        }
    }

    /**
     * Metodo que evalua el paginador para ubicar en bloques de 10 registros
     */
    public paginador() {
        this.paginas = [];
        this.inicio = 0;
        this.fin = 10;
        if (this.abandonados) {
            const paginaAdicional: boolean = (this.abandonados.length % 10) !== 0;
            let numeroPaginas = Math.round(this.abandonados.length / 10);
            numeroPaginas = paginaAdicional ? numeroPaginas + 1 : numeroPaginas;
            for (let i = 0; i < numeroPaginas; i++) {
                const element = numeroPaginas[i];
                this.paginas.push(element);
            }
        }
        this.spinner.hide();
    }

    /**
     * metodo que cambia de pagina
     */
    public cambiarPagina(valor: any) {
        switch (valor) {
            case 'a':
                this.inicio = 0;
                this.fin = 10;
                break;
            case 's':
                const mod = this.abandonados.length % 10;
                if (mod === 0) {
                    this.inicio = this.abandonados.length - 10;
                } else {
                    this.inicio = this.abandonados.length - mod;
                }
                this.fin = this.abandonados.length;
                break;
            default:
                this.inicio = (valor - 1) * 10;
                this.fin = valor * 10;
                break;
        }
    }

    /**
     * Método que valida la fecha Inicial y la anexa a una variable especifica filtroFechaInicio
     * @param event resive la fecha seleccionada por el usuario
     */
    public handlerDatePickeRInicio(event) {
        this.filtroFechaInicio = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
    }

    /**
     * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
     * @param   event resive la fecha seleccionada por el usuario
     */
    public handlerDatePickeRFin(event) {
        this.filtroFechaFin = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Método de control de Excepciones
     * @param   error  mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
